import React from "react";
import { Drawer, IconButton, Icon } from "rsuite";
import styled from "styled-components";

import NumbersFiltersForm from "./NumbersFiltersForm";


export default ({
    service,
    onChangeFilters,
    onChangeGroup,
    filter,
    filterModel,
    defaultFilter,
    allocatedNumbersLoading,
    showMobileFilters,
    isMobile = false,
    activeFiltersCount = 0,
    currentDisplay,
    formatMessage,
    ...props
}) => {

    const [showFiltersDrawer, setShowFiltersDrawer] = React.useState(false);

    const showFilters = () => {
        setShowFiltersDrawer(true);
    };

    const hideFilters = () => {
        setShowFiltersDrawer(false);
    };

    return (
        <>
            {isMobile
                ? <>
                    <Toggler
                        icon={<Icon icon="filter" />}
                        onClick={showFilters}
                    >
                        {activeFiltersCount}
                    </Toggler>
                    <Drawer
                        size="xs"
                        placement="bottom"
                        style={{ height: "240px" }}
                        show={showFiltersDrawer}
                        onHide={hideFilters}
                    >
                        <Drawer.Header>
                        </Drawer.Header>
                        <Drawer.Body>
                            <NumbersFiltersForm
                                {...{
                                    service,
                                    onChangeFilters,
                                    onChangeGroup,
                                    filter,
                                    filterModel,
                                    defaultFilter,
                                    allocatedNumbersLoading,
                                    currentDisplay,
                                    formatMessage
                                }}
                            />
                        </Drawer.Body>
                    </Drawer>
                    {/*<p>{props.testCount}</p>*/}
                </>

                : <NumbersFiltersForm
                    {...{
                        service,
                        onChangeFilters,
                        onChangeGroup,
                        filter,
                        filterModel,
                        defaultFilter,
                        allocatedNumbersLoading,
                        currentDisplay,
                        formatMessage
                    }}
                />
            }
        </>
    )
}

const Toggler = styled(IconButton)`
    && {
        color: #363434;
    }
`;